var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{directives:[{name:"debounce",rawName:"v-debounce:300ms",value:(_vm.leadPDFPrint),expression:"leadPDFPrint",arg:"300ms"}],attrs:{"debounce-events":"click","data-test":"download-lead-pdf"}},[_c('Icon',{attrs:{"type":"download"}}),_vm._v(" "+_vm._s(_vm.$t('Preuzmi PDF upita'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }